import React from "react";

import OnePanel from "./OnePanel";
import Text from "./Text";

const FPA = () => (
  <OnePanel title="Financial Planning and Analysis (FP&A)">
    <Text>
      In the game, the CEO sets expectation when s/he makes financial
      projections and in this section, We are going to evaluate the FP&amp;A
      data to see how well your team was able to meet those expectations.
    </Text>
  </OnePanel>
);

export default FPA;



// WEBPACK FOOTER //
// ./src/components/analysis/FPA.js